<app-upload
        [fileList]="fileList"
        [multiple]="isMultiple"
        [isDocumentPart]="true"
        [required]="required"
        [isUploadName]="false"
        [showUploadList]="showUploadList"
        [canRemove]="true"
        [path]="'task/'"
        [render]="uploadTemplate"
        [showProgress]="false"
        [batchUpload]="batchUpload"
        [inactiveUsers]="inactiveUsers"
        (uploadSuccess)="uploadSuccess($event)"
        (removeSuccess)="removeSuccess()"
        (upload)="uploadProcess = $event" class="upload-container">
</app-upload>
<ng-template #uploadTemplate>
    <ng-container *ngIf="render">
        <ng-container
            *ngTemplateOutlet="render"></ng-container>
    </ng-container>

    <ng-container *ngIf="!render">
        <div *ngIf="isSingleBtn">
            <span nz-icon nzType="plus" nzTheme="outline" class="attachment-icon" nz-tooltip nzTooltipTitle="Add attachment"></span>
        </div>
        <nz-spin *ngIf="!isSingleBtn" nzTip="Upload..." [nzSpinning]="uploadProcess !== 0">
            <div class="upload-content">
                Drop files here or click to upload
            </div>
        </nz-spin>
    </ng-container>
</ng-template>
